<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-container>
    <ik-data-table
      :model="model"
      :use-u-uid="true"
      entity-name="MemberRank"
      icon="mdi-cash-usd"
    />
  </v-container>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Level from '@/model/dataLayer/api/Vip/Level'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: Level
    })
  }
}
</script>
